import * as React from "react";
import { InfoViews, BottomViews, ImageTagViews } from "../../../components/FlashProducts/InfoViews";
import { BannerContainer } from "../../../../components/BannerContainer";
import { LinkTargetType } from "../../../../services/playground";
import { FlashProductContainer, FlashProductInfoBox } from "./styles";
import { getFlashProductDisplayExtend, hasActView, isSoldOut, } from "../../../../utils/playground/flashProduct";
import { transformAParam } from "../../../../utils/browser";
class MFlashProductsCard extends React.Component {
    constructor() {
        var _a, _b, _c, _d;
        super(...arguments);
        this.Info = {
            discount: (_b = (_a = this.props.productElement.extra) === null || _a === void 0 ? void 0 : _a.flash) === null || _b === void 0 ? void 0 : _b.discount,
            soldOut: this.props.productElement.stock <= 0,
            isRemindMe: (_d = (_c = this.props.productElement.extra) === null || _c === void 0 ? void 0 : _c.flash) === null || _d === void 0 ? void 0 : _d.isRemindMe,
        };
        this.setData = () => {
            const { productElement, index, activeId, remindMe } = this.props;
            const { isRemindMe = false } = this.Info;
            const { name, gpid, start, end, url } = productElement;
            const data = {
                isRemindMe,
                gpid,
                name,
                start,
                end,
                index,
                activeId,
                url,
            };
            remindMe(data);
        };
        this.onClick = () => {
            if (this.props.onClick) {
                this.props.onClick();
            }
        };
    }
    get flashTime() {
        const timeStamp = Number(this.props.productElement.start) * 1000;
        return new Date(timeStamp).toTimeString().slice(0, 5);
    }
    render() {
        const { productElement, isActView, state, multiTab, columnNum, isInApp, placeholderBg, stylesForCard, } = this.props;
        const { discount = "", soldOut, isRemindMe } = this.Info;
        const { name, price, originPrice, stock } = productElement;
        const extend = getFlashProductDisplayExtend(isActView, columnNum);
        const aProps = transformAParam({
            isInApp: !!isInApp,
            link: productElement.url,
            aTarget: LinkTargetType.Blank,
            onClick: this.onClick,
        });
        return (React.createElement(FlashProductContainer, Object.assign({ col: columnNum }, aProps),
            React.createElement(BannerContainer, { banner: {
                    img: productElement.img,
                    link: productElement.url,
                }, style: Object.assign({}, stylesForCard), className: "imgWrap", placeholderBg: placeholderBg, qnParams: {
                    w: 300,
                }, keepSize: true }, ImageTagViews(isActView, discount, columnNum, isSoldOut(soldOut, columnNum))),
            React.createElement(FlashProductInfoBox, { col: columnNum },
                React.createElement(InfoViews, { columnNum: columnNum, price: price, originalPrice: originPrice, name: name, showName: extend.showName, showPrice: hasActView(columnNum) ? true : false }),
                React.createElement(BottomViews, { columnNum: columnNum, multiTab: multiTab, state: state, stock: stock, soldOut: soldOut, startTime: this.flashTime, isRemindMe: !!isRemindMe, remindMe: this.setData, price: price, originalPrice: originPrice, isInApp: isInApp }))));
    }
}
export default MFlashProductsCard;
